
import { Language } from '@/context/LanguageContext';

interface SitemapEntry {
  url: string;
  lastmod: string;
  changefreq: string;
  priority: string;
  language?: Language;
}

// Generate XML for a sitemap chunk
export const generateSitemapXML = (entries: SitemapEntry[]): string => {
  let sitemap = '<?xml version="1.0" encoding="UTF-8"?>\n';
  sitemap += '<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9" xmlns:xhtml="http://www.w3.org/1999/xhtml">\n';
  
  entries.forEach(entry => {
    sitemap += '  <url>\n';
    sitemap += `    <loc>${entry.url}</loc>\n`;
    sitemap += `    <lastmod>${entry.lastmod}</lastmod>\n`;
    sitemap += `    <changefreq>${entry.changefreq}</changefreq>\n`;
    sitemap += `    <priority>${entry.priority}</priority>\n`;
    
    // Add hreflang for multilingual content
    if (entry.language) {
      sitemap += `    <xhtml:link rel="alternate" hreflang="${entry.language}" href="${entry.url}" />\n`;
    }
    
    sitemap += '  </url>\n';
  });
  
  sitemap += '</urlset>';
  return sitemap;
};

// Generate sitemap index file
export const generateSitemapIndex = (baseUrl: string, sitemapCount: number): string => {
  const currentDate = new Date().toISOString();
  
  let sitemapIndex = '<?xml version="1.0" encoding="UTF-8"?>\n';
  sitemapIndex += '<sitemapindex xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">\n';
  
  for (let i = 1; i <= sitemapCount; i++) {
    sitemapIndex += '  <sitemap>\n';
    sitemapIndex += `    <loc>${baseUrl}/sitemap-${i}.xml</loc>\n`;
    sitemapIndex += `    <lastmod>${currentDate}</lastmod>\n`;
    sitemapIndex += '  </sitemap>\n';
  }
  
  sitemapIndex += '</sitemapindex>';
  return sitemapIndex;
};
